export default __webpack_public_path__ + "static/media/one.69c25ee6.pdf";